import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopLevelStructureComponent } from './top-level-structure.component';
import { TopLevelStructureRoutingModule } from './top-level-structure-routing.module';



@NgModule({
  declarations: [
    TopLevelStructureComponent
  ],
  imports: [
    CommonModule,
    TopLevelStructureRoutingModule
  ],
  exports: [
    // TopLevelStructureComponent
  ]
})
export class TopLevelStructureModule { }
